import { Box, Grid } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';
import IGridComponent from '../../../components/grid/i-grid.component';
import IButton from '../../../components/button/i-button.component';
import { useContext, useEffect, useState } from 'react';
import { isNotEmpty } from '../../common/util.services';
import { AppContext } from '../../../app-context';
import { getOtherCostValues } from '../../master-data/masterdata.services';

const OtherCostComponent = (props: any) => {
  const [othCost, setOthCost] = useState(props.data);
  const appContext = useContext(AppContext);
  const [message, setMessage] = useState('');
  const [othCostValues, setOthCostValues] = useState<any>([]);
  const [inputCodeList] = useState(props.inputCodeList);
  const [othCostOriginal, setOthCostOriginal] = useState([]);
  const columns: GridColDef[] = [
    { field: 'code', headerName: 'Input Code', filterable: false, sortable: false, editable: true, width: 150, type: 'singleSelect',
      valueOptions: inputCodeList,
      valueFormatter: (code: any) => code, 
      valueSetter: (value, row) => { row.code = value; return value; }},
    { field: 'type', headerName: 'Cost Type', filterable: false, sortable: false, editable: true, width: 300, type: 'singleSelect',
      valueOptions: othCostValues,
      valueFormatter: (type: any) => type, 
      valueSetter: (value, row) => { row.type = value; return value; }},
    { field: 'unitCost', headerName: 'Unit Rate', filterable: false, sortable: false, editable: true, width: 120, type: 'number',
      headerAlign: 'left', align: 'left',
      valueFormatter: (unitCost: any) => unitCost, 
      valueSetter: (value, row) => { row.unitCost = value; return value; }},
    { field: 'unit', headerName: '# Units', filterable: false, sortable: false, editable: true, width: 120, type: 'number',
      headerAlign: 'left', align: 'left',
      valueFormatter: (unit: any) => unit, 
      valueSetter: (value, row) => { row.unit = value; return value; }}
  ];

  useEffect(() => { 
    getOtherCostValues(appContext,
      (response: any) => {
        let value = response.data;
        value = value.filter((r: any) => !(r === 'NA'));
        setOthCostValues([...value]);
      }, (error: any) => {
        console.log(error);
        appContext.setShowLoader(false);
      });
  }, [])

  useEffect(() => { 
    setOthCostOriginal(JSON.parse(JSON.stringify(othCost)));
  }, [])

  const onSubmit = () => {
    let sameType = false;
    for(let i = 0; i < othCost.length; ++i) {
      for(let j = i + 1; j < othCost.length; ++j) {
        if(isNotEmpty(othCost[i].unitCost) && isNotEmpty(othCost[j].unitCost) && 
           othCost[i].code === othCost[j].code && othCost[i].type === othCost[j].type) {
          sameType = true;
        }
      }
    }
    if(sameType) {
      setMessage('Same input code and cost type selected multiple times');
    } else {
      let otherCost: any = [];
      for(let i = 0; i < othCost.length; ++i) {
        if(isNotEmpty(othCost[i].code) && isNotEmpty(othCost[i].type) &&
           isNotEmpty(othCost[i].unitCost) && isNotEmpty(othCost[i].unit)){
          otherCost.push(othCost[i]);
        }
      }
      props.submit(otherCost);
    }
  }

  const addRow = (params: any) => {
    const rows = [...othCost];
    let row = {rowId: othCost.length + 1, code: 'NA', type: '', unitCost: '', unit: 1};
    rows.splice(othCost.length, 0, row);
    setOthCost(rows);
  }

  const onCancel = () => {
    props.cancel(othCostOriginal);
  }

  const processRowUpdate = (updatedRow: any, originalRow: any) => {
    const nextRow = { 
      ...originalRow, 
      value: originalRow.unitCost * originalRow.unit 
    };
  
    return nextRow; 
  }

  return <div className='master-detail'>
    <Box sx={{ fontSize: '15px', fontWeight: 'bold', color: 'red' }}>{message}</Box>
    <Grid container spacing={1}>
      <IGridComponent title='' rows={othCost} columns={columns} getRowId={(row: any) => row.rowId} 
        maxHeight={'50vh'} hideFooterPagination={true} showAddBtn={true} addRow={addRow} processRowUpdate={processRowUpdate}/>
    </Grid>
    <div className='btn-panel'>
      <IButton name='submit' label='Submit' color="primary" onActionEvent={onSubmit}/>
      <IButton name='cancel' label='Cancel' color="secondary" onActionEvent={onCancel}/>
    </div>
  </div>
}

export default OtherCostComponent;
